export default __webpack_public_path__ + "static/media/Pay.e8e39204.svg";